$(function () {
    const hash = $(location).prop('hash')
    const $accordions = [...$('.accordion')]

    if ($accordions.length) {
        $accordions.forEach($accordion => {
            const $items = $('.accordion__item', $accordion)
            const $headers = $('.accordion__item__header', $accordion)
            const $contents = $('.accordion__item__content', $accordion)

            $headers.on('click touch', function (e) {                
                e.preventDefault();
                const $content = $($(this).siblings('.accordion__item__content')[0])
                $items.removeClass('accordion__item--open')
                $contents.not($content).slideUp(function () {
                    $(this).attr('aria-expanded', false)
                    $(this).parent().removeClass('accordion__item--opened')
                })
                if ($content.parent().hasClass('accordion__item--opened')) {
                    $content.slideUp(() => {
                        $(this).attr('aria-expanded', false)
                        $content.parent().removeClass('accordion__item--opened')
                    })
                } else {
                    $content.slideDown(() => {
                        $(this).attr('aria-expanded', true)
                        $content.parent().addClass('accordion__item--opened')
                    })
                }
            })
        })
    }
})